import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  DestroyRef,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef,
  createNgModule,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';

import type { DooFinderSearchComponent as OriginalComponent } from '../../shared/doo-finder-search/doo-finder-search.component';

@Component({
  selector: 'custom-lazy-doo-finder-search',
  standalone: false,
  templateUrl: './lazy-doo-finder-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyDooFinderSearchComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/doo-finder/shared/doo-finder-search/doo-finder-search.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;

  private component: ComponentRef<OriginalComponent>;
  private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.featureToggleService
      .enabled$('dooFinder')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async enabled => {
        if (enabled) {
          await this.renderComponent();
        } else {
          this.anchor.clear();
        }
      });
  }

  private async renderComponent() {
    const module = await import(`../../doo-finder.module`).then(m => m.DooFinderModule);

    const { DooFinderSearchComponent: originalComponent } =
      await import('../../shared/doo-finder-search/doo-finder-search.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });

    this.component.changeDetectorRef.markForCheck();
  }
}
